import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SeoSchema from "../components/SeoSchema";
import Hero from "../components/sections/Hero";
import BrandMarquee from "../components/sections/Marquee";
import Services from "../components/sections/Services";
import About from "../components/sections/About";
import Gallery from "../components/sections/Gallery";
import Reviews from "../components/sections/Reviews";
import Estimate from "../components/sections/Estimate";

export default function Home() {
  return (
    <div className="grain relative">
      <SeoSchema />
      <Navbar />
      <main>
        <Hero />
        <BrandMarquee />
        <Services />
        <About />
        <Gallery />
        <Reviews />
        <Estimate />
      </main>
      <Footer />
    </div>
  );
}
